/**
 * Parse an evaluator's structured output.
 *
 * Providers are asked for a JSON object, but some models occasionally wrap an
 * otherwise valid object in one Markdown code fence. Accept only that exact,
 * bounded wrapper (or bare JSON): no prose extraction and no syntax repair.
 */
export function parseEvaluatorOutput(raw: string | null | undefined): Record<string, unknown> | null {
  if (!raw) return null;

  const trimmed = raw.trim();
  const fenced = /^```(?:json)?[ \t]*\r?\n([\s\S]*?)\r?\n```$/i.exec(trimmed);
  const candidate = (fenced?.[1] ?? trimmed).trim();

  try {
    const parsed = JSON.parse(candidate);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed as Record<string, unknown>
      : null;
  } catch {
    return null;
  }
}
